import { el } from 'redom';
import { debounce } from 'lodash';

import OutsideClickEventRegistration from 'lib/outside-click-event-registration';

import {
  displayElementAroundAnchor
} from 'utilities/element-position';

class FloatedInput {

  constructor(configuration) {

    this.value = configuration.value;
    this.placeholder = configuration.placeholder;
    this.anchor = configuration.anchor;
    this.viewport = configuration.viewport;
    this.onComplete = configuration.onComplete;
    this.onCancel = configuration.onCancel;

    this.outsideEventRegistration = null;
    this.viewportScrollHandler = null;

    this.input = null;

    this.el = el('.floated-input-main', [
      this.renderInput()
    ]);

  }

  renderInput() {

    this.input = el('input', {
      type: 'text',
      placeholder: this.placeholder,
      value: this.value,
      onkeyup: this.handleInputKeyupEvent.bind(this),
      onpaste: this.handlePasteEvent.bind(this)
    });

    return this.input;

  }

  onmount() {

    setTimeout(this.initialize.bind(this), 1);

  }

  onunmount() {

    this.uninitialize();

  }

  initialize() {

    this.outsideEventRegistration = new OutsideClickEventRegistration(this.el, this.handleOutsideClickEvent.bind(this));

    this.positionInput();

    this.registerViewportScrollEventHandler();

    this.input.focus();

  }

  uninitialize() {

    this.outsideEventRegistration.cancel();

    this.removeViewportScrollHandler();

  }

  handleViewportScroll() {

    this.positionInput();

  }

  handlePasteEvent(event) {

    event.stopPropagation();

    // return false;

  }

  handleInputKeyupEvent(event) {

    const input = event.target;

    if (event.key === 'Escape') {
      this.handleOutsideClickEvent();
      return;
    }

    if (event.key !== 'Enter') {
      return;
    }

    const altText = input.value;

    this.onComplete(altText, this.el);

  }

  handleOutsideClickEvent() {

    this.onCancel(this.el);

  }

  registerViewportScrollEventHandler() {

    this.viewportScrollHandler = debounce(this.handleViewportScroll.bind(this), 10);

    this.viewport.addEventListener('scroll', this.viewportScrollHandler);

  }

  removeViewportScrollHandler() {

    this.viewport.removeEventListener('scroll', this.viewportScrollHandler);

  }

  positionInput() {

    displayElementAroundAnchor(this.el, this.anchor, void 0, 10, 10);

  }

}

export default FloatedInput;